import React, { FunctionComponent } from "react"
import PositiveResponseCrudService from "../utils/PositiveResponseCrudService"
import { Button, Spinner } from "react-bootstrap"
import PositiveResponseHashService from "../utils/PositiveResponseHashService"
import PositiveResponseService from "../utils/PositiveResponseService"
import "./PositiveResponsesHeader.css"

const PositiveResponsesHeader: FunctionComponent<{}> = () => {

    const { state } = PositiveResponseService
    const { addPositiveResponseRerun, ignorePositiveResponseErrors } = PositiveResponseCrudService
    const { getBatch, checkIfAddIsDirty } = PositiveResponseHashService
    const batch = getBatch()
    const isIsDirty = checkIfAddIsDirty()
    const hasBadTickets = state.badTicketPositiveResponses.length > 0
    const busy = state.busyId > -1
    const firstLoad = state.firstLoad

    return (
        <div className="PositiveResponsesHeader">
            {(hasBadTickets && !busy) && <div className="PositiveResponsesHeaderBatchBtns">
                <div className="PositiveResponsesHeaderBatchBtn">
                    <Button disabled={!isIsDirty} variant="primary" onClick={() => (addPositiveResponseRerun(batch))}>Rerun</Button>
                </div>
                <div className="PositiveResponsesHeaderBatchBtn">
                    <Button disabled={!isIsDirty} variant="danger" onClick={() => (ignorePositiveResponseErrors(batch))}>Ignore</Button>
                </div>
            </div>}
            {(!hasBadTickets && !busy && !firstLoad) && <div className="PositiveResponsesHeaderNoBadTickets">
                <p>No action needed</p>
            </div>}
            {(busy && !firstLoad) && <div className="PositiveResponsesHeaderBusy">
                <Spinner id="bad-ticket-positive-response-header-busy-spinner" animation="border" />
                <p>tprID: <strong>{state.busyId}</strong></p>
            </div>}
        </div>
    )
}

export default PositiveResponsesHeader